var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "--axis --axis-x", style: { width: _vm.width + "px" } },
    _vm._l(_vm.items, function(item) {
      return _c(
        "span",
        {
          key: item.value,
          staticClass: "--axis-x-item",
          class: { "--zero": item.positionX < 0.1 },
          style: { left: item.positionX + "px" }
        },
        [_vm._v("\n\t\t" + _vm._s(item.label) + "\n\t")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }